import type { ComposedForm } from 'lib-node-question-builder';

import useIsWriteAccessDisabled from '~/common/hooks/useIsWriteAccessDisabled';
import { READONLY_CONDITION } from '~/pages/Loan1003DataGrids/common/utils/utils';

import type { BorrowerData } from '../../../types';

function createTextQuestion(
  label: string,
  questionName: string,
  isRequired: boolean = false,
) {
  return {
    elementType: 'question',
    type: 'text',
    label,
    name: `borrowerAliases[{i}].${questionName}`,
    placeholder: label,
    span: 3,
    rules: {
      required: isRequired,
    },
    conditions: {
      isDisabled: READONLY_CONDITION,
    },
  } as const;
}

type AlsoKnownAsFieldArrayProps = {
  form: ComposedForm<BorrowerData['formData']>;
};

export function AlsoKnownAsFieldArray({
  form,
}: Readonly<AlsoKnownAsFieldArrayProps>) {
  const isWriteAccessDisabled = useIsWriteAccessDisabled();

  return (
    <form.FieldArray
      name="borrowerAliases"
      label=""
      enableAdd={!isWriteAccessDisabled}
      addButtonLabel="Add New"
      template={[
        {
          elementType: 'component',
          type: 'grid',
          name: 'borrowerAliasGridRow',
          style: { padding: '0 0.5rem' },
          columns: 13,
          fields: [
            createTextQuestion('First Name', 'firstName', true),
            createTextQuestion('Middle Name', 'middleName'),
            createTextQuestion('Last Name', 'lastName'),
            createTextQuestion('Suffix', 'suffixName'),
            {
              elementType: 'component',
              type: 'fieldArrayDeleteButton',
              name: 'deleteBorrowerAliasButton',
              value: '{i}',
              conditions: {
                isDisabled: READONLY_CONDITION,
              },
            },
          ],
        },
      ]}
    />
  );
}
